import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { Manufacturer } from '../models/manufacturer';
import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';

@Injectable()
export class ManufacturerService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }

  public getAll(): Promise<Manufacturer[]> {
    return new Promise((resolve, reject) => {
      this.http.get<Manufacturer[]>('/api/manufacturer/getall').subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public get(id: Number): Promise<Manufacturer> {
    return new Promise((resolve, reject) => {
      this.http.get<Manufacturer>('/api/manufacturer/get?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public save(manufacturer: Manufacturer): Promise<Manufacturer> {
    return new Promise((resolve, reject) => {
      if (manufacturer.is_edit) {
        this.http.put<Manufacturer>('/api/manufacturer/put', manufacturer).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully updated manufacturer');
        }, error => {
          console.log(error);
          reject();
        });
      } else {
        this.http.post<Manufacturer>('/api/manufacturer/post', manufacturer).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully added manufacturer');
        }, error => {
          console.log(error);
          reject();
        });
      }
    });
  }


  public getResults(page: Page, name: string): Promise<PagedData<Manufacturer>> {
    const pagedData = new PagedData<Manufacturer>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Name'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      const params = '&name=' + name;

      this.http.get<ServerData>(environment.apiUrl + '/manufacturer/gettable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.total;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          const manufacturer = new Manufacturer();
          manufacturer.init(jsonObj.id, jsonObj.name, jsonObj.expired);
          pagedData.data.push(manufacturer);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  public getExcel(page: Page, name: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let params = '?name=' + name;

      this.http.get<any>('/api/manufacturer/getexcel' + params).subscribe(data => {
        let blob = this.converBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }
  converBase64toBlob(content, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [
    ];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType
    }); //statement which creates the blob
    return blob;
  }
}
